import { apiClient } from '../client'
import {
    OfferCreateResponse,
    OfferEntityType,
    OfferMessagePayload,
    OfferMessageResponse,
    OfferPayload,
    OfferPreviewPayload,
    OfferTemplatesResponse,
} from './types'

export const createOffer = async (payload: OfferPayload) => {
    const response = await apiClient('v1/offer', {
        method: 'POST',
        data: payload,
    })

    return response.data as OfferCreateResponse
}

export const previewOffer = async (payload: OfferPreviewPayload) => {
    const { previewCount, data } = payload

    const response = await apiClient(`v1/offer/pdf/${previewCount}`, {
        method: 'POST',
        responseType: 'blob',
        transformResponse: [
            function (data: Blob) {
                const blob = new window.Blob([data], { type: 'application/pdf' })
                return window.URL.createObjectURL(blob)
            },
        ],
        data: data,
    })

    return { pdfUrl: response.data }
}

export const getOfferTemplates = async (entityType: OfferEntityType) => {
    const response = await apiClient(`v1/offer/templates/${entityType}`, {
        method: 'GET',
    })

    return response.data as OfferTemplatesResponse
}

export const getOfferMessage = async (payload: OfferMessagePayload) => {
    const response = await apiClient('v1/offer/message', {
        method: 'POST',
        data: payload,
    })

    return response.data.data as OfferMessageResponse
}
